import { SVGProps } from 'react';

/** Grid icon used for spreadsheet extensions (.xls, .xlsx, .csv). */
export const SpreadsheetIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      data-icon
      width="16"
      height="16"
      viewBox="0 -35.5 169 195"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M110 111L110 11" stroke="#6FD1A1" strokeWidth="14" strokeLinecap="round" />
      <path d="M161 61.8823L9 61.8823" stroke="#6FD1A1" strokeWidth="14" strokeLinecap="round" />
      <path d="M59 114L59 11" stroke="#6FD1A1" strokeWidth="14" strokeLinecap="round" />
      <rect x="7" y="7" width="155" height="110" rx="20" stroke="#6FD1A1" strokeWidth="14" />
    </svg>
  );
};
